/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
// styles
import injectSheet from 'react-jss';
import styles from './sectiongroup_styles';


/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - SECTION GROUP ~~~~~~~~~~ ========== */
const SectionGroup = (props) => {
    const {
        row,
        column,
        secondary,
        child,
        disabled
    } = props
    return <div
        className={`sectiongroup ${props.classes.sectiongroup} ${secondary ? 'secondary' : ''} ${column ? 'column' : ''} ${row ? 'row' : ''} ${child ? 'child' : ''} ${disabled ? 'disabled' : ''}`}>
        {props.children}
    </div>
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SectionGroup);
